import React from "react"
import { Tabs, Tab } from 'react-bootstrap';
import { useNavigate } from "react-router";
import BasicTooltip from "./Tooltip/BasicTooltip";
import { BsInfoCircleFill } from "react-icons/bs";
import DocList from "./DocList/DocList";

const ProfileTabs = ({
    newsProfile,
    podcastProfile,
    cveProfile,
    mitreProfile,
    routes,
    name,
    activeGroupKey,
    activeSubNewsKey,
    setActiveSubNewsKey,
    activeSubCveKey,
    setActiveSubCveKey,
}) => {

    const navigate = useNavigate();
    const recommendationTabTitle = (label = 'Recommendations') => (
        <span className='d-inline-flex align-items-center gap-1'>
            <span>{label}</span>
            <BasicTooltip text='Recommendation score range from 0 to 1, higher means more relevant'>
                <span className='d-inline-flex align-items-center mt-1'>
                    <BsInfoCircleFill className='text-muted' size={14} style={{ cursor: 'pointer' }} />
                </span>
            </BasicTooltip>
        </span>
    );

    const secondaryProfiles = (repo) => {
        if (repo === 'news') {
            const profileForNews = [];
            if (podcastProfile) profileForNews.push(podcastProfile);
            if (cveProfile) profileForNews.push(cveProfile);
            if (mitreProfile) profileForNews.push(mitreProfile);
            return profileForNews;
        } else if (repo === 'podcasts') {
            const profileForPodcasts = [];
            if (newsProfile) profileForPodcasts.push(newsProfile);
            if (cveProfile) profileForPodcasts.push(cveProfile);
            if (mitreProfile) profileForPodcasts.push(mitreProfile);
            return profileForPodcasts;
        } else if (repo === 'cve') {
            const profileForCves = [];
            if (newsProfile) profileForCves.push(newsProfile);
            if (podcastProfile) profileForCves.push(podcastProfile);
            if (mitreProfile) profileForCves.push(mitreProfile);
            return profileForCves;
        }
        return null;
    };
    return (
        <Tabs
            defaultActiveKey='news'
            className='nav nav-tabs nav-tabs-second-level'
            activeKey={activeGroupKey}
            onSelect={(k) => navigate(`${routes[name][k]}`)}
        >
            <Tab eventKey='news' title='News' data-testid='news-tab-panel'>
                <Tabs
                    defaultActiveKey='recommendations'
                    className='nav nav-tabs nav-tabs-second-level'
                    activeKey={activeSubNewsKey}
                    onSelect={(k) => setActiveSubNewsKey(k)}
                >
                    <Tab
                        eventKey='recommendations'
                        title={recommendationTabTitle()}
                        data-testid='news-recommendations-tab-panel'
                    >
                        {newsProfile &&
                            newsProfile.profileId &&
                            activeGroupKey === `news` &&
                            activeSubNewsKey === 'recommendations' && (
                                <DocList
                                    key={`news-recommendations-${newsProfile.profileId}`}
                                    profilePrimary={newsProfile}
                                    activeGroupKey={activeGroupKey}
                                    profileSecondary={secondaryProfiles('news')}
                                    list='recommendations'
                                    showAddWatchList={
                                        newsProfile.roles.indexOf('curator') > -1
                                    }
                                    showRemove={false}
                                />
                            )}
                    </Tab>
                    <Tab
                        eventKey='watchlist'
                        title='Watchlist'
                        data-testid='news-watchlist-tab-panel'
                    >
                        {newsProfile &&
                            newsProfile.profileId &&
                            activeGroupKey === `news` &&
                            activeSubNewsKey === 'watchlist' && (
                                <DocList
                                    key={`news-watchlist-${newsProfile.profileId}`}
                                    profilePrimary={newsProfile}
                                    activeGroupKey={activeGroupKey}
                                    profileSecondary={secondaryProfiles('news')}
                                    list='watchlist'
                                    showAddWatchList={false}
                                    showRemove={newsProfile.roles.indexOf('curator') > -1}
                                />
                            )}
                    </Tab>
                    <Tab
                        eventKey='rejected'
                        title='Rejected'
                        data-testid='news-rejected-tab-panel'
                    >
                        {newsProfile &&
                            newsProfile.profileId &&
                            activeGroupKey === `news` &&
                            activeSubNewsKey === 'rejected' && (
                                <DocList
                                    key={`news-rejected-${newsProfile.profileId}`}
                                    profilePrimary={newsProfile}
                                    activeGroupKey={activeGroupKey}
                                    profileSecondary={secondaryProfiles('news')}
                                    list='rejectlist'
                                    showAddWatchList={false}
                                    showRemove={newsProfile.roles.indexOf('curator') > -1}
                                />
                            )}
                    </Tab>
                </Tabs>
            </Tab>
            <Tab
                eventKey='podcasts'
                title='Podcasts'
                data-testid='podcasts-tab-panel'
            >
                <Tabs
                    defaultActiveKey='recommendations'
                    className='nav nav-tabs nav-tabs-second-level'
                    activeKey={activeSubNewsKey}
                    onSelect={(k) => setActiveSubNewsKey(k)}
                >
                    <Tab
                        eventKey='recommendations'
                        title={recommendationTabTitle()}
                        data-testid='podcasts-recommendations-tab-panel'
                    >
                        {podcastProfile &&
                            podcastProfile.profileId &&
                            activeGroupKey === `podcasts` &&
                            activeSubNewsKey === 'recommendations' && (
                                <DocList
                                    key={`podcasts-recommendations-${podcastProfile.profileId}`}
                                    profilePrimary={podcastProfile}
                                    // profileSecondary={newsProfile}
                                    list='recommendations'
                                    showAddWatchList={
                                        podcastProfile.roles.indexOf('curator') > -1
                                    }
                                    showRemove={false}
                                />
                            )}
                    </Tab>
                    <Tab
                        eventKey='watchlist'
                        title='Watchlist'
                        data-testid='podcasts-watchlist-tab-panel'
                    >
                        {podcastProfile &&
                            podcastProfile.profileId &&
                            activeGroupKey === `podcasts` &&
                            activeSubNewsKey === 'watchlist' && (
                                <DocList
                                    key={`podcasts-watchlist-${podcastProfile.profileId}`}
                                    profilePrimary={podcastProfile}
                                    // profileSecondary={cveProfile}
                                    list='watchlist'
                                    showAddWatchList={false}
                                    showRemove={
                                        podcastProfile.roles.indexOf('curator') > -1
                                    }
                                />
                            )}
                    </Tab>
                    {/*<Tab eventKey='search' title='Search'></Tab>*/}
                    <Tab
                        eventKey='rejected'
                        title='Rejected'
                        data-testid='podcasts-rejected-tab-panel'
                    >
                        {podcastProfile &&
                            podcastProfile.profileId &&
                            activeGroupKey === `podcasts` &&
                            activeSubNewsKey === 'rejected' && (
                                <DocList
                                    key={`podcasts-rejected-${podcastProfile.profileId}`}
                                    profilePrimary={podcastProfile}
                                    // profileSecondary={cveProfile}
                                    list='rejectlist'
                                    showAddWatchList={false}
                                    showRemove={
                                        podcastProfile.roles.indexOf('curator') > -1
                                    }
                                />
                            )}
                    </Tab>
                </Tabs>
            </Tab>
            <Tab eventKey='cve' title='CVEs' data-testid='cve-tab-panel'>
                <Tabs
                    defaultActiveKey='recommendations'
                    className='nav nav-tabs nav-tabs-second-level'
                    activeKey={activeSubCveKey}
                    onSelect={(k) => setActiveSubCveKey(k)}
                >
                    <Tab
                        eventKey='recommendations'
                        title={recommendationTabTitle()}
                        data-testid='cve-recommendations-tab-panel'
                    >
                        {cveProfile &&
                            cveProfile.profileId &&
                            activeGroupKey === 'cve' &&
                            activeSubCveKey === 'recommendations' && (
                                <DocList
                                    key={`cve-recommendations-${cveProfile.profileId}`}
                                    profilePrimary={cveProfile}
                                    activeGroupKey={activeGroupKey}
                                    profileSecondary={secondaryProfiles('cve')}
                                    list={'recommendations'}
                                    showAddWatchList={
                                        cveProfile.roles.indexOf('curator') > -1
                                    }
                                    showRemove={false}
                                />
                            )}
                    </Tab>
                    <Tab
                        eventKey='watchlist'
                        title='Watchlist'
                        data-testid='cve-watchlist-tab-panel'
                    >
                        {cveProfile &&
                            cveProfile.profileId &&
                            activeGroupKey === 'cve' &&
                            activeSubCveKey === 'watchlist' && (
                                <DocList
                                    key={`cve-watchlist-${cveProfile.profileId}`}
                                    profilePrimary={cveProfile}
                                    activeGroupKey={activeGroupKey}
                                    profileSecondary={secondaryProfiles('cve')}
                                    list={'watchlist'}
                                    showAddWatchList={false}
                                    showRemove={cveProfile.roles.indexOf('curator') > -1}
                                />
                            )}
                    </Tab>
                    {/*<Tab eventKey='search' title='Search'></Tab>*/}
                    <Tab
                        eventKey='rejected'
                        title='Rejected'
                        data-testid='cve-rejected-tab-panel'
                    >
                        {cveProfile &&
                            cveProfile.profileId &&
                            activeGroupKey === 'cve' &&
                            activeSubCveKey === 'rejected' && (
                                <DocList
                                    key={`cve-rejected-${cveProfile.profileId}`}
                                    profilePrimary={cveProfile}
                                    activeGroupKey={activeGroupKey}
                                    profileSecondary={secondaryProfiles('cve')}
                                    list={'rejectlist'}
                                    showAddWatchList={false}
                                    showRemove={cveProfile.roles.indexOf('curator') > -1}
                                />
                            )}
                    </Tab>
                </Tabs>
            </Tab>
        </Tabs>
    )
}

export default ProfileTabs;
